/* Didinsky 2027: interacciones ligeras (vista previa de color, miniaturas con flecha, reseñas, propiedades y textos de colección plegables) */
(function () {
  'use strict';

  /* ---- Vista previa de la gafa al pasar por una miniatura de color ---- */
  function swatchUrl(sw) {
    var bg = getComputedStyle(sw).backgroundImage || '';
    var m = bg.match(/url\(["']?([^"')]+)["']?\)/);
    if (!m) return null;
    var url = m[1];
    if (/[?&]width=\d+/.test(url)) return url.replace(/([?&])width=\d+/, '$1width=900');
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=900';
  }
  function show(sw) {
    var card = sw.closest('.product-card');
    if (!card) return;
    var media = card.querySelector('.product-card__media');
    var url = swatchUrl(sw);
    if (!media || !url) return;
    var img = media.querySelector('img.d27-swatch-preview');
    if (!img) {
      img = document.createElement('img');
      img.className = 'd27-swatch-preview';
      img.alt = '';
      img.setAttribute('aria-hidden', 'true');
      media.appendChild(img);
    }
    if (img.getAttribute('src') !== url) img.src = url;
    media.classList.add('d27-previewing');
  }
  function hide(sw) {
    var card = sw.closest('.product-card');
    var media = card && card.querySelector('.product-card__media');
    if (media) media.classList.remove('d27-previewing');
  }
  document.addEventListener('mouseover', function (e) {
    var sw = e.target.closest && e.target.closest('.product-card .swatches .color-swatch');
    if (sw) show(sw);
  });
  document.addEventListener('mouseout', function (e) {
    var sw = e.target.closest && e.target.closest('.product-card .swatches .color-swatch');
    if (sw && !(e.relatedTarget && sw.contains(e.relatedTarget))) hide(sw);
  });
  document.addEventListener('focusin', function (e) {
    var sw = e.target.closest && e.target.closest('.product-card .swatches .color-swatch');
    if (sw) show(sw);
  });
  document.addEventListener('focusout', function (e) {
    var sw = e.target.closest && e.target.closest('.product-card .swatches .color-swatch');
    if (sw) hide(sw);
  });

  /* ---- Reseñas plegables bajo "Características" ---- */
  function findReviews(btn) {
    var wrap = btn.closest('[id^="shopify-block-"], .product__block, .block') || btn.parentElement;
    var scope = btn.closest('product-info') || document;
    var t = scope.querySelector('[id^="shopify-block-"][id*="klaviyo_reviews"]');
    if (t) return t;
    var n = wrap && wrap.nextElementSibling;
    return n || null;
  }
  function initReviews() {
    var btn = document.getElementById('d27-reviews-btn');
    if (!btn || btn.dataset.d27Ready) return;
    var target = findReviews(btn);
    if (!target) return;
    btn.dataset.d27Ready = '1';
    if (!target.id) target.id = 'd27-reviews-panel';
    btn.setAttribute('aria-controls', target.id);
    target.classList.add('d27-reviews-collapsed');
    function set(open) {
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      target.classList.toggle('d27-reviews-collapsed', !open);
    }
    btn.addEventListener('click', function () {
      set(btn.getAttribute('aria-expanded') !== 'true');
    });
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('.product__rating, a[href*="review"], a[href*="resen"]');
      if (!a || btn.contains(a)) return;
      set(true);
      setTimeout(function () { btn.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 50);
    });
  }
  /* ---- "Propiedades" plegable, con el mismo formato que los acordeones ---- */
  function initProps() {
    document.querySelectorAll('product-info .product__highlights.with-heading').forEach(function (box) {
      if (box.dataset.d27Ready) return;
      var head = box.querySelector(':scope > p');
      if (!head) return;
      box.dataset.d27Ready = '1';
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'd27-acc-btn';
      btn.setAttribute('aria-expanded', 'false');
      var label = document.createElement('span');
      label.textContent = head.textContent.trim();
      var icon = document.createElement('span');
      icon.className = 'd27-rv-icon';
      icon.setAttribute('aria-hidden', 'true');
      icon.textContent = '+';
      btn.appendChild(label);
      btn.appendChild(icon);
      head.replaceWith(btn);
      box.classList.add('d27-acc', 'd27-acc--closed');
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') !== 'true';
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        box.classList.toggle('d27-acc--closed', !open);
        if (open) window.dispatchEvent(new Event('resize'));
      });
    });
  }


  /* ---- Textos de colección: cada titular plegable (el primero abierto) ---- */
  function initCollectionText() {
    if (!document.body.classList.contains('template-collection')) return;
    document.querySelectorAll('.shopify-section .rte').forEach(function (rte) {
      if (rte.dataset.d27Acc || rte.closest('.product-card, .collection-banner-section, .d27-ct')) return;
      var heads = rte.querySelectorAll(':scope > h2');
      if (heads.length < 2) heads = rte.querySelectorAll(':scope > h3');
      if (heads.length < 2) return;
      rte.dataset.d27Acc = '1';
      rte.classList.add('d27-ct');
      var tag = heads[0].tagName;
      Array.prototype.forEach.call(heads, function (h, i) {
        var item = document.createElement('div');
        item.className = 'd27-ct__item';
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'd27-ct__btn';
        var title = document.createElement(tag.toLowerCase());
        title.className = 'd27-ct__title';
        title.innerHTML = h.innerHTML;
        var icon = document.createElement('span');
        icon.className = 'd27-rv-icon';
        icon.setAttribute('aria-hidden', 'true');
        icon.textContent = '+';
        btn.appendChild(title);
        btn.appendChild(icon);
        var panel = document.createElement('div');
        panel.className = 'd27-ct__panel';
        var n = h.nextSibling;
        while (n && !(n.nodeType === 1 && n.tagName === tag)) {
          var next = n.nextSibling;
          panel.appendChild(n);
          n = next;
        }
        h.parentNode.insertBefore(item, h);
        h.remove();
        item.appendChild(btn);
        item.appendChild(panel);
        var open = i === 0;
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        panel.hidden = !open;
        btn.addEventListener('click', function () {
          var o = btn.getAttribute('aria-expanded') !== 'true';
          btn.setAttribute('aria-expanded', o ? 'true' : 'false');
          panel.hidden = !o;
        });
      });
    });
  }

  /* ---- Miniaturas de color: máximo 6 visibles y flecha para desplazar ---- */
  function initSwatchScroll() {
    document.querySelectorAll('.product-card .swatches').forEach(function (ul) {
      var wrap = ul.parentElement;
      if (!wrap) return;
      var over = ul.scrollWidth > ul.clientWidth + 2;
      var prev = wrap.querySelector(':scope > .d27-sw-prev');
      var next = wrap.querySelector(':scope > .d27-sw-next');
      if (!over) {
        if (prev) prev.hidden = true;
        if (next) next.hidden = true;
        return;
      }
      if (!next) {
        prev = document.createElement('button');
        prev.type = 'button';
        prev.className = 'd27-sw-arrow d27-sw-prev';
        prev.setAttribute('aria-label', 'Colores anteriores');
        prev.textContent = '‹';
        next = document.createElement('button');
        next.type = 'button';
        next.className = 'd27-sw-arrow d27-sw-next';
        next.setAttribute('aria-label', 'Más colores');
        next.textContent = '›';
        wrap.insertBefore(prev, ul);
        ul.after(next);
        var step = function (dir) { ul.scrollBy({ left: dir * 100, behavior: 'smooth' }); };
        prev.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); step(-1); });
        next.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); step(1); });
        ul.addEventListener('scroll', function () { update(ul, prev, next); }, { passive: true });
      }
      update(ul, prev, next);
    });
  }
  function update(ul, prev, next) {
    prev.hidden = ul.scrollLeft <= 2;
    next.hidden = ul.scrollLeft + ul.clientWidth >= ul.scrollWidth - 2;
  }
  window.addEventListener('resize', function () { initSwatchScroll(); });

  function initAll() { initReviews(); initProps(); initCollectionText(); initSwatchScroll(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  window.addEventListener('load', initAll);
  /* al cambiar de variante el tema puede re-renderizar la ficha */
  document.addEventListener('variant:changed', function () { setTimeout(initAll, 50); });
  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; initAll(); });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
